// function initMV(o){const e=".js-konva-base",t=o?750:1920,n=o?1314:1200;var r=o?mateprod_image_sp_arr.length:mateprod_image_arr.length,i=0,a=!1,d=!1,c=0===$(window).scrollTop()?0:r-1,s=new Konva.Stage({container:"konva",width:t,height:n}),l=new Konva.Layer;s.add(l);var p=[...Array(r)].map(((e,a)=>{var d=new Image;return d.onload=function(){l.add(new Konva.Image({x:0,y:0,image:d,width:t,height:n,visible:a===c,id:"op"+String(a)}));const o=100*++i/r+"%";document.documentElement.style.setProperty("--mate-load-progress",o),i==r&&$(window).trigger("prodMvLoad")},d.src=o?mateprod_image_sp_arr[a]:mateprod_image_arr[a],d}));$(window).on("prodMvLoad",(function(){$(".c-loading").fadeOut(500,(function(){a=!0}))}));var g,u,m=0===$(window).scrollTop()?0:r-1;$("body").addClass("fixed"),$(e).on("touchstart",(function(o){h||(g=o.originalEvent.touches[0].clientY,o.preventDefault())})),$(document).on("touchstart",(function(o){h||(u=o.originalEvent.touches[0].clientY,o.preventDefault())}));let h=!1;function f(o){h=!0,$("body").addClass("fixed");const e=setInterval((function(){m===mateprod_timing_bg_change&&($(".js-mvBaseImg").toggleClass("is-changed"),$(".js-mvFirst").toggleClass("is-changed")),m===mateprod_timing_show_text&&$(".js-mvText").toggleClass("is-changed"),l.children[m]&&l.children.find((o=>o.attrs.id==="op"+m)).hide(),m+=o,l.children[m]&&l.children.find((o=>o.attrs.id==="op"+m)).show(),(1===o&&m>=p.length-1||-1===o&&m<=0)&&(h=!1,clearInterval(e),1===o?(d=!0,$("body").removeClass("fixed")):(d=!1,$("body").addClass("fixed")))}),mateprod_image_time/p.length)}$(e).on("wheel touchmove",(function(o){if(!a)return;if(h)return void o.preventDefault();const e=0===$(window).scrollTop();var t,n=o.originalEvent;if(n.changedTouches&&n.changedTouches[0]){var r=n.changedTouches[0].clientY;if(Math.abs(g-r)<20)return;t=g>r?1:-1,g=r}else t=n.deltaY>0?1:-1;return m>0&&!e?void 0:!(!d||1!==t)||void(m>=p.length&&e&&1===t||1===t&&m>=p.length-1||-1===t&&m<=0||(f(t),o.preventDefault()))})),$(window).on("wheel touchmove",(function(o){const e=0===$(window).scrollTop();var t,n=o.originalEvent;if(n.changedTouches&&n.changedTouches[0]){var r=n.changedTouches[0].clientY;if(Math.abs(u-r)<20)return;t=u>r?1:-1,u=r}else t=n.deltaY>0?1:-1;!e||1===t||m<=0||h||$("body").hasClass("fixed")||(f(t),o.preventDefault())}))}window.onunload=function(){},window.addEventListener("pageshow",(function(o){o.persisted&&window.location.reload()})),$((function(){$("html,body").stop().animate({scrollTop:0},100).promise().done((function(){$(window).trigger("prodPageReady")}))})),$(window).on("beforeunload pagehide",(function(o){$(".c-loading").show(),$("html,body").stop().animate({scrollTop:0},10)})),$(window).on("prodPageReady",(function(){const o=window.matchMedia("(min-width: 768px)"),e=!o.matches;function t(o){const e=!o.matches;$(".js-videoImageChange").each((function(){const o=$(this).data(e?"sp":"pc");$(this).attr("src",o)}))}o.addEventListener("change",t),t(o),initMV(e);const n=document.querySelector(".prod-fusion-sideslide_list"),r=gsap.utils.toArray(".prod-fusion-sideslide_item");gsap.to(r,{xPercent:-100*(r.length-1),ease:"none",scrollTrigger:{trigger:n,pin:!0,scrub:1,end:()=>"+="+n.offsetWidth}}),gsap.timeline({scrollTrigger:{trigger:".prod-fusion-batt_over",start:"top center"}}).from(".prod-fusion-batt_lead",{opacity:0,duration:.5}).from(".prod-fusion-batt_desc",{opacity:0,duration:.5}).from(".prod-fusion-batt_spec",{opacity:0,duration:.5}).from(".prod-fusion-batt_notice",{opacity:0,duration:.5}),gsap.timeline({scrollTrigger:{trigger:".prod-fusion-fold",start:"top center"}}).from(".prod-fusion-fold_lead",{opacity:0,duration:1}).from(".prod-fusion-fold_desc",{opacity:0,duration:1},"-=0.8").from(".prod-fusion-fold_spec",{opacity:0,duration:1}),$(".js-prod-cmn-colorSlider").slick({arrow:!0,dots:!0,fade:!0});gsap.timeline({ease:"none",scrollTrigger:{trigger:".prod-cmn-color2",start:"top center",once:!0}}).set(".prod-cmn-colorOp_head",{y:20}).set(".prod-cmn-colorOp_lead",{y:20}).set(".prod-cmn-color2_slideName",{opacity:0,y:20}).set(".prod-cmn-color2 .slick-arrow",{opacity:0}).set(".prod-cmn-color2 .slick-dots",{opacity:0}).to(".prod-cmn-colorOp_head",{opacity:1,y:0,duration:.5}).to(".prod-cmn-colorOp_lead",{opacity:1,y:0,duration:.5}).to(".prod-cmn-colorOp_head, .prod-cmn-colorOp_lead",{opacity:0,duration:.5},"+=1").to(".prod-cmn-colorOp",{opacity:0,duration:1}).to(".prod-cmn-color_slideName",{opacity:1,y:0,duration:.5}).to(".prod-cmn-color2 .slick-arrow",{opacity:1,duration:.5},"-=0.5").to(".prod-cmn-color2 .slick-dots",{opacity:1,duration:.5},"-=0.5")}));

function initMV(o) {
	const e = ".js-konva-base",
		t = o ? 750 : 1920,
		n = o ? 1314 : 1200;
	var r = o ? mateprod_image_sp_arr.length : mateprod_image_arr.length,
		i = 0,
		a = !1,
		d = !1,
		c = 0 === $(window).scrollTop() ? 0 : r - 1,
		s = new Konva.Stage({
			container: "konva",
			width: t,
			height: n
		}),
		l = new Konva.Layer;
	s.add(l);
	var p = [...Array(r)].map(((e, a) => {
		var d = new Image;
		return d.onload = function() {
			l.add(new Konva.Image({
				x: 0,
				y: 0,
				image: d,
				width: t,
				height: n,
				visible: a === c,
				id: "op" + String(a)
			}));
			const o = 100 * ++i / r + "%";
			document.documentElement.style.setProperty("--mate-load-progress", o), i == r && $(window).trigger("prodMvLoad")
		}, d.src = o ? mateprod_image_sp_arr[a] : mateprod_image_arr[a], d
	}));
	$(window).on("prodMvLoad", (function() {
		$(".c-loading").fadeOut(500, (function() {
			a = !0
		}))
	}));
	var g, u, m = 0 === $(window).scrollTop() ? 0 : r - 1;
	$("body").addClass("fixed"), $(e).on("touchstart", (function(o) {
		h || (g = o.originalEvent.touches[0].clientY, o.preventDefault())
	})), $(document).on("touchstart", (function(o) {
		h || (u = o.originalEvent.touches[0].clientY, o.preventDefault())
	}));
	let h = !1;

	function f(o) {
		h = !0, $("body").addClass("fixed");
		const e = setInterval((function() {
			m === mateprod_timing_bg_change && ($(".js-mvBaseImg").toggleClass("is-changed"), $(".js-mvFirst").toggleClass("is-changed")), m === mateprod_timing_show_text && $(".js-mvText").toggleClass("is-changed"), l.children[m] && l.children.find((o => o.attrs.id === "op" + m)).hide(), m += o, l.children[m] && l.children.find((o => o.attrs.id === "op" + m)).show(), (1 === o && m >= p.length - 1 || -1 === o && m <= 0) && (h = !1, clearInterval(e), 1 === o ? (d = !0, $("body").removeClass("fixed")) : (d = !1, $("body").addClass("fixed")))
		}), mateprod_image_time / p.length)
	}
	$(e).on("wheel touchmove", (function(o) {
		if (!a) return;
		if (h) return void o.preventDefault();
		const e = 0 === $(window).scrollTop();
		var t, n = o.originalEvent;
		if (n.changedTouches && n.changedTouches[0]) {
			var r = n.changedTouches[0].clientY;
			if (Math.abs(g - r) < 20) return;
			t = g > r ? 1 : -1, g = r
		} else t = n.deltaY > 0 ? 1 : -1;
		return m > 0 && !e ? void 0 : !(!d || 1 !== t) || void(m >= p.length && e && 1 === t || 1 === t && m >= p.length - 1 || -1 === t && m <= 0 || (f(t), o.preventDefault()))
	})), $(window).on("wheel touchmove", (function(o) {
		const e = 0 === $(window).scrollTop();
		var t, n = o.originalEvent;
		if (n.changedTouches && n.changedTouches[0]) {
			var r = n.changedTouches[0].clientY;
			if (Math.abs(u - r) < 20) return;
			t = u > r ? 1 : -1, u = r
		} else t = n.deltaY > 0 ? 1 : -1;
		!e || 1 === t || m <= 0 || h || $("body").hasClass("fixed") || (f(t), o.preventDefault())
	}))
}
window.onunload = function() {}, window.addEventListener("pageshow", (function(o) {
	o.persisted && window.location.reload()
})), $((function() {
	$("html,body").stop().animate({
		scrollTop: 0
	}, 100).promise().done((function() {
		$(window).trigger("prodPageReady")
	}))
})), $(window).on("beforeunload pagehide", (function(o) {
	$(".c-loading").show(), $("html,body").stop().animate({
		scrollTop: 0
	}, 10)
})), $(window).on("prodPageReady", (function() {
	const o = window.matchMedia("(min-width: 768px)"),
		e = !o.matches;

	function t(o) {
		const e = !o.matches;
		$(".js-videoImageChange").each((function() {
			const o = $(this).data(e ? "sp" : "pc");
			$(this).attr("src", o)
		}))
	}
	o.addEventListener("change", t), t(o), initMV(e);
	const n = document.querySelector(".prod-fusion-sideslide_list"),
		r = gsap.utils.toArray(".prod-fusion-sideslide_item");
	// gsap.to(r, {
	// 	xPercent: -100 * (r.length - 1),
	// 	ease: "none",
	// 	scrollTrigger: {
	// 		trigger: n,
	// 		pin: !0,
	// 		scrub: 1,
	// 		end: () => "+=" + n.offsetWidth
	// 	}
	// }), 
    gsap.timeline({
		scrollTrigger: {
			trigger: ".prod-fusion-batt_over",
			start: "top center"
		}
	}).from(".prod-fusion-batt_lead", {
		opacity: 0,
		duration: .5
	}).from(".prod-fusion-batt_desc", {
		opacity: 0,
		duration: .5
	}).from(".prod-fusion-batt_spec", {
		opacity: 0,
		duration: .5
	}).from(".prod-fusion-batt_notice", {
		opacity: 0,
		duration: .5
	}), gsap.timeline({
		scrollTrigger: {
			trigger: ".prod-fusion-fold",
			start: "top center"
		}
	}).from(".prod-fusion-fold_lead", {
		opacity: 0,
		duration: 1
	}).from(".prod-fusion-fold_desc", {
		opacity: 0,
		duration: 1
	}, "-=0.8").from(".prod-fusion-fold_spec", {
		opacity: 0,
		duration: 1
	}), $(".js-prod-cmn-colorSlider").slick({
		arrow: !0,
		dots: !0,
		fade: !0
	});
	gsap.timeline({
		ease: "none",
		scrollTrigger: {
			trigger: ".prod-cmn-color2",
			start: "top center",
			once: !0
		}
	}).set(".prod-cmn-colorOp_head", {
		y: 20
	}).set(".prod-cmn-colorOp_lead", {
		y: 20
	}).set(".prod-cmn-color2_slideName", {
		opacity: 0,
		y: 20
	}).set(".prod-cmn-color2 .slick-arrow", {
		opacity: 0
	}).set(".prod-cmn-color2 .slick-dots", {
		opacity: 0
	}).to(".prod-cmn-colorOp_head", {
		opacity: 1,
		y: 0,
		duration: .5
	}).to(".prod-cmn-colorOp_lead", {
		opacity: 1,
		y: 0,
		duration: .5
	}).to(".prod-cmn-colorOp_head, .prod-cmn-colorOp_lead", {
		opacity: 0,
		duration: .5
	}, "+=1").to(".prod-cmn-colorOp", {
		opacity: 0,
		duration: 1
	}).to(".prod-cmn-color_slideName", {
		opacity: 1,
		y: 0,
		duration: .5
	}).to(".prod-cmn-color2 .slick-arrow", {
		opacity: 1,
		duration: .5
	}, "-=0.5").to(".prod-cmn-color2 .slick-dots", {
		opacity: 1,
		duration: .5
	}, "-=0.5")
}));